// @flow
import React, { useCallback } from "react";
import RadioGroup from "./RadioGroup";

import "./selecao-radio-base.css";

type Props = {
  nomeSelecao: string,
  listaItens: Array<any>,
  itemSelecionado: any,
  campoId: string,
  campoDescricao: string,
  onChange: (number | string) => mixed,
  disabled: boolean,
  radioName: string,
};

export default function SelecaoRadioBase({
  nomeSelecao,
  listaItens,
  itemSelecionado,
  campoId,
  campoDescricao,
  radioName,
  onChange,
  disabled,
}: Props) {
  const handleItemChange = useCallback(
    (event: SyntheticInputEvent<>) => {
      const parsed = parseInt(event.target.value, 10);
      const idSelecionado = isNaN(parsed) ? event.target.value : parsed;
      onChange(idSelecionado);
    },
    [onChange]
  );

  return (
    <div className="SelecaoRadioBase">
      <div className="SelecaoRadioBase__nome">{nomeSelecao}</div>
      <RadioGroup
        nome={(radioName === undefined ? nomeSelecao : radioName)
          .replace(/\s+/g, "-")
          .toLowerCase()}
        itens={listaItens}
        itemSelecionado={itemSelecionado}
        onChange={handleItemChange}
        campoId={campoId}
        campoDescricao={campoDescricao}
        disabled={disabled}
      />
    </div>
  );
}

SelecaoRadioBase.defaultProps = {
  campoId: "id",
  campoDescricao: "traducao",
  disabled: false,
};
